export default "__VITE_ASSET__D3D0WMWg__"